
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { InventoryBin, InventoryUiClient } from '../../../backend/backendapi';
import { initClient } from '../../../../api';

@Component({
  name: 'BinDeleteModal',
})
export default class BinDeleteModal extends Vue {
  bins: InventoryBin[] = [];

  //api
  private readonly service = initClient(InventoryUiClient);

  public open(bins: InventoryBin[]): void {
    this.bins = bins;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async deleteSelected(): Promise<void> {
    if (!this.bins.length) {
      return;
    }
    let deleted = 0;
    for (let bin of this.bins) {
      try {
        await this.service.deleteBin(bin.id);
      } catch (e) {
        this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e));
      }
    }
    if (deleted > 0) {
      this.$toasted.info(this.$t('txtDeleted').toString());
    }
    this.$emit('deleted');
    this.dismiss();
  }
}
